import React, { useMemo, useState } from 'react';
import { Icon } from '../../design/Icon';

/**
 * Searchable, grouped multi-select from the mockup community picker (.tree/.tree-row).
 * groups: [{ id, name, items: [{ id, name, aliases?: string[], meta?: string }] }]
 */
export function HierarchyTreePicker({ groups, selected = [], onApply, searchPlaceholder = 'Search names or aliases', emptyText = 'No match. Search also checks aliases.', applyLabel = 'Apply' }) {
  const [query, setQuery] = useState('');
  const [picked, setPicked] = useState(selected);

  const visible = useMemo(() => {
    const q = query.trim().toLowerCase();
    return groups
      .map((group) => ({
        ...group,
        items: group.items.filter(
          (item) => !q || item.name.toLowerCase().includes(q) || (item.aliases || []).join(' ').toLowerCase().includes(q)
        ),
      }))
      .filter((group) => group.items.length);
  }, [groups, query]);

  const toggle = (id, on) => setPicked((current) => (on ? [...current, id] : current.filter((x) => x !== id)));

  return (
    <>
      <input
        className="input"
        placeholder={searchPlaceholder}
        aria-label={searchPlaceholder}
        style={{ marginBottom: 6 }}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <div className="tree">
        {visible.length === 0 && (
          <div className="caption" style={{ padding: 12 }}>
            {emptyText}
          </div>
        )}
        {visible.map((group) => (
          <React.Fragment key={group.id}>
            <div className="tree-row" style={{ fontWeight: 600, cursor: 'default' }}>
              <Icon name="sitemap" className="ico-sm" />
              {group.name}
              <span className="cnt">{group.items.length}</span>
            </div>
            {group.items.map((item) => (
              <label key={item.id} className="tree-row child">
                <input type="checkbox" checked={picked.includes(item.id)} onChange={(e) => toggle(item.id, e.target.checked)} />
                {item.name}
                {item.meta && <span className="cnt">{item.meta}</span>}
              </label>
            ))}
          </React.Fragment>
        ))}
      </div>
      <div className="menu-sep" />
      <div className="row between">
        <span className="caption">{picked.length} selected</span>
        <button type="button" className="btn btn-primary btn-sm" onClick={() => onApply(picked)}>
          {applyLabel}
        </button>
      </div>
    </>
  );
}
